import React from 'react';

import { RequiredFlag } from '../required-flag';
import useEmailInput from './email-input.controller';

const ID = 'email-input';
export interface EmailInputProps {
    required?: boolean;
    valid?: boolean;
    isValidCallback?: (valid: boolean) => void;
    onChange?: (value: string) => void;
    onFocusChange?: () => void;
    value?: string;
    errorMessage?: React.ReactNode;
    label?: React.ReactNode;
    helpMessage?: React.ReactNode;
    autoFocus?: boolean;
    submitted?: boolean;
    id?: string;

    className?: string;
    noAutoComplete?: boolean;
    noConditionedStyling?: boolean;
    isDisabled?: boolean;

    styles?: EmailInputStyles;
}

export interface EmailInputStyles {
    container?: string;
    label?: {
        container?: string;
        required?: string;
        label?: string;
    };
    input?: {
        outside_container?: string;
        inside_container?: string;
        icon_container?: string;
        icon?: string;
        input?: string;
    };
    error?: {
        container?: string;
        message?: string;
    };
    info?: {
        container?: string;
        message?: string;
    };
}

export const EmailInput = (props: EmailInputProps) => {
    const viewProps = useEmailInput(props);

    return (
        <div
            id={`${ID}-${props.id}`}
            className={props.styles?.container ?? 'inline-flex w-full flex-col items-start justify-start gap-1'}>
            {props.label && (
                <div className='mb-0! flex w-full flex-col'>
                    <div className={props.styles?.label?.container ?? 'inline-flex items-center gap-1'}>
                        <span className={props.styles?.label?.label ?? 'text-foreground-default text-sm font-medium'}>{props.label}</span>
                        <RequiredFlag required={props.required} />
                    </div>
                    {props.helpMessage && (
                        <>
                            <small className='form-text text-muted'>{props.helpMessage}</small>
                        </>
                    )}
                </div>
            )}
            <div
                className={
                    props.styles?.input?.outside_container ??
                    'bg-background-surface border-border-default inline-flex h-11 flex-col items-start justify-center gap-3.5 self-stretch rounded-md border'
                }>
                <input
                    className={
                        props.styles?.input?.input ??
                        'text-foreground- h-full w-full justify-start self-stretch rounded-md px-4 text-base font-medium focus:outline-none'
                    }
                    data-testid='emailInput'
                    autoComplete={props.noAutoComplete ? 'off' : 'email'}
                    name='no-complete-email'
                    id={props.id ? props.id + '-email-input' : 'email-input'}
                    value={props.value}
                    autoFocus={props.autoFocus}
                    type='text'
                    placeholder='user@telloport.com'
                    onFocus={() => {
                        viewProps.changeTouched(true);
                        props.onFocusChange && props.onFocusChange();
                    }}
                    required={props.required}
                    onChange={(event) => {
                        if (props.onChange) props.onChange(event.target.value);
                        viewProps.isValid();
                    }}
                    disabled={props.isDisabled}
                />
            </div>

            {viewProps.valid === false && props.value && viewProps.touched === true && (
                <div className={props.styles?.error?.container ?? 'flex w-full'}>
                    <small className={props.styles?.error?.message ?? 'text-status-danger text-xs'}>
                        {props.errorMessage ? props.errorMessage : 'Please fill in a valid email address.'}{' '}
                    </small>
                    <br />
                </div>
            )}

            {props.helpMessage && (
                <div className={props.styles?.info?.container ?? 'flex w-full'}>
                    <small className={props.styles?.info?.message ?? 'text-brand-muted text-xs'}>{props.helpMessage}</small>
                </div>
            )}
        </div>
    );
};
